import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
    root: {
        display: "inline-flex",
        alignItems: "center",
    },
    text: { marginLeft: theme.spacing(1) },
}), { name: "IconText" });
/**
 * Иконка рядом с текстом.
 */
const IconText = React.forwardRef(function (props, ref) {
    const classes = useStyles();
    return (React.createElement("div", Object.assign({}, props, { className: `${classes.root} ${props.className}`, ref: ref }),
        props.icon,
        typeof props.text == 'string' ? (React.createElement("span", { className: classes.text }, props.text)) : props.text));
});
export default IconText;
